import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import ChangePasswordForm from "../components/ChangePasswordForm";
import { toast } from "sonner";
import { User, KeyRound, LogOut, Save } from "lucide-react";

export default function Account() {
  const { user, updateProfile, logout } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState(user?.name || "");

  const saveName = async () => {
    if (!name.trim()) { toast.error("Name required"); return; }
    await updateProfile({ name: name.trim() });
    toast.success("Profile updated");
  };

  return (
    <div className="space-y-6 max-w-2xl">
      <div>
        <div className="eyebrow text-[#D4AF37]">Account & Security</div>
        <h1 className="font-display text-3xl sm:text-4xl mt-1">Account / Settings</h1>
      </div>

      <div className="card-lux p-6">
        <div className="flex items-center gap-2 mb-4"><User className="w-5 h-5 text-[#D4AF37]" /><h2 className="font-semibold">Owner profile</h2></div>
        <label className="text-xs text-[#94A3B8]">Owner name</label>
        <input value={name} onChange={(e) => setName(e.target.value)} data-testid="account-name"
          className="w-full mt-1 mb-3 px-4 py-3 rounded-lg bg-[#0A0C10] border border-[#2A3042] outline-none focus:border-[#D4AF37] text-base" />
        <label className="text-xs text-[#94A3B8]">Login email</label>
        <input value={user?.email || ""} disabled data-testid="account-email"
          className="w-full mt-1 mb-4 px-4 py-3 rounded-lg bg-[#12151E] border border-[#2A3042] text-[#64748B] text-base" />
        <button onClick={saveName} data-testid="save-profile-btn" className="gold-btn px-5 py-2.5 rounded-lg text-sm inline-flex items-center gap-2"><Save className="w-4 h-4" /> Save profile</button>
      </div>

      <div className="card-lux p-6">
        <div className="flex items-center gap-2 mb-4"><KeyRound className="w-5 h-5 text-[#D4AF37]" /><h2 className="font-semibold">Change password</h2></div>
        <ChangePasswordForm />
      </div>

      <div className="card-lux p-6">
        <div className="flex items-center justify-between">
          <div>
            <h2 className="font-semibold mb-1">Sign out</h2>
            <p className="text-sm text-[#94A3B8]">End your session on this device.</p>
          </div>
          <button data-testid="account-signout" onClick={() => logout().then(() => nav("/login"))}
            className="px-4 py-2.5 rounded-lg border border-[#2A3042] text-[#94A3B8] hover:text-[#EF4444] hover:border-[#EF4444]/40 inline-flex items-center gap-2 text-sm">
            <LogOut className="w-4 h-4" /> Sign out
          </button>
        </div>
      </div>
    </div>
  );
}
